import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Carrentalswithdriversinmumbai() {



  const cardData =
  {
    keyword: 'Car Rentals with Drivers in Mumbai',
    heading: 'Aaryan Travels: Car Rentals with Drivers in Mumbai',
    headingDescription: ' Aaryan Travels offers convenient Car Rentals with Drivers in Mumbai for local travel, airport pickups, corporate meetings, and outstation trips. Whether you need a sedan for business travel, an SUV for family outings, or a luxury car for VIP transfers, our chauffeur-driven vehicles ensure a comfortable and hassle-free experience. With professional, well-mannered drivers, GPS-enabled cars, and transparent pricing, we make travel across Mumbai smooth and reliable. From South Mumbai to Navi Mumbai, Andheri to Bandra, Aaryan Travels provides 24/7 car rental services with drivers tailored to your schedule, making city travel stress-free and efficient.',

    top: 'Top Places to Visit in Mumbai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924 overlooking the Arabian Sea, the Gateway of India is Mumbai’s most iconic monument. It served as a ceremonial entrance during British rule. Tourists gather to enjoy ferry rides to Elephanta Caves and soak in coastal views. Street vendors and bustling crowds add to the lively atmosphere. The Gateway of India is Mumbai’s timeless symbol of pride."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, popularly known as the Queen’s Necklace, is a 3.6 km-long curved boulevard lined with palm trees and sea views. At night, the streetlights resemble a dazzling necklace. Locals and tourists come for morning jogs, sunset views, and roadside chai. The ocean breeze adds a refreshing charm. Marine Drive is Mumbai’s classic seaside escape."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A UNESCO World Heritage Site, CST is a stunning example of Victorian Gothic Revival architecture built in 1887. Its stained glass windows, domes, and intricate carvings resemble a palace more than a railway station. Thousands commute daily through its historic halls. Illuminated beautifully at night, it becomes a visual masterpiece. CST is Mumbai’s living monument of heritage and functionality."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal hangouts known for its local street food like pav bhaji, bhel puri, and kulfi. Families enjoy camel rides, sand play, and lively evenings. Nearby luxury hotels and celebrity houses add glamour. Sunset walks here are unforgettable. Juhu Beach is Mumbai’s fun-loving seaside paradise."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Situated on a tiny islet in the Arabian Sea, Haji Ali Dargah is a 15th-century mosque and tomb accessible via a narrow pathway during low tide. The white marble structure appears to float on water, creating a magical view. Devotees from all faiths visit for blessings and qawwali music. Haji Ali is Mumbai’s serene symbol of unity and spirituality."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these UNESCO-listed rock-cut caves date back to the 5th century. The main cave features grand sculptures of Lord Shiva, including the famous three-faced Trimurti. Visitors reach the site via ferry from Gateway of India. Surrounded by lush greenery and ancient art, it feels like a journey through time. Elephanta Caves are Mumbai’s heritage wonder."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Dedicated to Lord Ganesha, Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most visited shrines. Celebrities, politicians, and locals offer prayers daily. The gold-plated dome and peaceful interiors offer spiritual calm. Tuesdays see massive crowds of devotees. Siddhivinayak is Mumbai’s divine center of devotion and hope."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a cable-stayed marvel connecting South Mumbai to the Western Suburbs. Driving across offers panoramic sea views and Mumbai’s skyline. Lit up at night, it becomes a futuristic spectacle. It has reduced travel time significantly while enhancing the city’s modern identity. The Sea Link is Mumbai’s engineering icon."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling street market famous for clothes, jewelry, antiques, and souvenirs. Iconic cafés like Leopold and Café Mondegar add to the retro vibe. Tourists bargain for quirky finds while enjoying vibrant street life. It is a must-visit for shoppers and explorers. Colaba Causeway is Mumbai’s colorful shopping hub."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is one of the world’s largest urban forests, offering dense greenery, caves, and wildlife safaris. Kanheri Caves inside the park showcase ancient Buddhist rock-cut structures. Visitors enjoy trekking, cycling, and toy train rides through nature. Deer, butterflies, and birds are commonly spotted. SGNP is Mumbai’s natural escape from the chaos."
  }
],


 "services": [
  {
    "name": "Car Rentals with Drivers in Mumbai",
    "description": "Our Car Rentals with Drivers in Mumbai provide convenient and comfortable travel solutions tailored to your needs. Whether you require daily commutes, airport transfers, or city tours, our professional drivers ensure timely pickups and safe journeys across Mumbai. Choose from a variety of vehicles including sedans and SUVs, all maintained to high standards for your comfort and safety."
  },
  {
    "name": "Mumbai Car Hire with Driver",
    "description": "Mumbai Car Hire with Driver offers flexible and reliable transportation options for individuals and corporate clients. With professional chauffeurs experienced in navigating Mumbai’s traffic, we guarantee a hassle-free ride experience. Ideal for business meetings, airport transfers, and leisure trips."
  },
  {
    "name": "Chauffeur Driven Car Rental Mumbai",
    "description": "Experience the luxury and convenience of Chauffeur Driven Car Rental in Mumbai. Our trained drivers provide courteous, punctual, and safe service, making your travel stress-free. Choose from premium sedans and SUVs for corporate events, special occasions, or daily commuting."
  },
  {
    "name": "Luxury Car with Driver Mumbai",
    "description": "Travel in style with our Luxury Car with Driver service in Mumbai. Featuring high-end vehicles such as Mercedes, Audi, and BMW, we offer executive-class comfort paired with professional chauffeurs. Perfect for VIP clients, weddings, and premium corporate travel."
  },
  {
    "name": "Executive Car Rental Mumbai",
    "description": "Executive Car Rental in Mumbai caters to business professionals seeking dependable and stylish rides. Our fleet of executive cars, coupled with skilled drivers, ensures you arrive at your meetings or events on time and in comfort."
  },
  {
    "name": "Best Driver Car Rentals Mumbai",
    "description": "Best Driver Car Rentals Mumbai focuses on delivering quality service with well-trained drivers and clean, well-maintained vehicles. We prioritize safety, punctuality, and customer satisfaction for all your transportation needs within the city."
  },
  {
    "name": "Affordable Car Rental with Driver Mumbai",
    "description": "Affordable Car Rental with Driver in Mumbai provides cost-effective travel solutions without compromising on service quality. Suitable for daily commutes, airport transfers, and local sightseeing, our service offers excellent value with professional drivers."
  },
  {
    "name": "Corporate Car Hire Mumbai",
    "description": "Corporate Car Hire in Mumbai is designed for businesses requiring reliable transportation for employees and clients. Our chauffeur-driven cars ensure professional, comfortable, and timely travel, ideal for corporate events, client pickups, and office commutes."
  },
  {
    "name": "Sedan Car with Driver Mumbai",
    "description": "Sedan Car with Driver Mumbai offers comfortable and spacious sedans for individual or group travel. Perfect for airport transfers, city rides, and business travel, our service guarantees punctuality and professional chauffeurs."
  },
  {
    "name": "SUV Rental with Driver Mumbai",
    "description": "SUV Rental with Driver in Mumbai provides spacious and comfortable vehicles ideal for family trips, group travel, and corporate outings. Our experienced drivers ensure a smooth journey while you relax in premium SUVs."
  },
  {
    "name": "Premium Car & Driver Mumbai",
    "description": "Premium Car & Driver service in Mumbai combines luxury vehicles with top-notch chauffeur service. Suitable for high-profile clients and special occasions, we deliver an exceptional travel experience with attention to detail and professionalism."
  },
  {
    "name": "Monthly Car with Driver Mumbai",
    "description": "Monthly Car with Driver plans in Mumbai offer businesses and individuals cost-effective, long-term car rental solutions. Enjoy dedicated vehicles with professional drivers for daily use, backed by flexible packages and priority service."
  },
  {
    "name": "Online Car with Driver Mumbai",
    "description": "Online Car with Driver booking in Mumbai makes scheduling your chauffeur-driven rides quick and easy. Through our digital platform, you can book vehicles anytime with real-time availability, secure payments, and instant confirmations."
  },
  {
    "name": "One Day Car with Driver Mumbai",
    "description": "Our One Day Car with Driver service in Mumbai is ideal for short-term needs such as city tours, business meetings, or special events. Enjoy professional chauffeur service with flexible timing and vehicle options to suit your itinerary."
  },
  {
    "name": "Mumbai Chauffeur Car Services",
    "description": "Mumbai Chauffeur Car Services provide premium and reliable chauffeur-driven transportation across the city. From airport pickups to full-day rentals, our skilled drivers and well-maintained fleet offer a comfortable, safe, and punctual travel experience."
  }
],
"tableData": [
  ["Car Rentals with Drivers in Mumbai", "Mumbai Car Hire with Driver"],
  ["Chauffeur Driven Car Rental Mumbai", "Luxury Car with Driver Mumbai"],
  ["Executive Car Rental Mumbai", "Best Driver Car Rentals Mumbai"],
  ["Affordable Car Rental with Driver Mumbai", "Corporate Car Hire Mumbai"],
  ["Sedan Car with Driver Mumbai", "SUV Rental with Driver Mumbai"],
  ["Premium Car & Driver Mumbai", "Monthly Car with Driver Mumbai"],
  ["Online Car with Driver Mumbai", "One Day Car with Driver Mumbai"],
  ["Mumbai Chauffeur Car Services", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Car Rentals with Drivers in Mumbai",
    "WhyChoosedescription": "Aaryan Travels offers dependable car rental services with professional drivers throughout Mumbai."
  },
  {
    "WhyChooseheading": "Convenient and Timely Pickup Anywhere in Mumbai",
    "WhyChoosedescription": "Our drivers ensure prompt pickups and smooth rides to your desired destinations."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Every Journey",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cars maintained for your safety and comfort."
  },
  {
    "WhyChooseheading": "Experienced and Licensed Drivers Familiar with Mumbai Roads",
    "WhyChoosedescription": "Our drivers have thorough knowledge of Mumbai’s traffic and routes to provide efficient travel."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Enjoy upfront pricing covering fuel, tolls, and driver allowances for a hassle-free experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking and Assistance",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, changes, and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Options for Local and Outstation Trips",
    "WhyChoosedescription": "Choose from hourly rentals, point-to-point rides, or long-distance journeys based on your needs."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options to Suit Your Preferences",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers depending on your group size and luggage."
  }
]




































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer car rentals with drivers in Mumbai?',
    answer: 'Yes, Aaryan Travels provides reliable car rental services with professional drivers across Mumbai for local and outstation travel.',
  },
  {
    question: 'How can I book a car rental with a driver in Mumbai with Aaryan Travels?',
    answer: 'You can book through our website, mobile app, or by contacting our 24x7 customer support team for quick assistance.',
  },
  {
    question: 'What types of cars are available for rental with drivers in Mumbai?',
    answer: 'We offer a range of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit your travel needs.',
  },
  {
    question: 'Can I rent a car with a driver for hourly, daily, or long-term use in Mumbai?',
    answer: 'Yes, Aaryan Travels offers flexible rental packages including hourly, daily, and long-term rentals in Mumbai.',
  },
  {
    question: 'Are the drivers experienced and familiar with Mumbai routes?',
    answer: 'Absolutely. Our drivers are licensed, professional, and well-acquainted with Mumbai’s traffic and routes to ensure a smooth ride.',
  },
  {
    question: 'Is car rental with driver service available 24x7 in Mumbai?',
    answer: 'Yes, Aaryan Travels provides round-the-clock car rental services with drivers in Mumbai.',
  },
  {
    question: 'What safety and hygiene measures are followed for car rentals with drivers in Mumbai?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene protocols for passenger safety.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for car rentals with drivers in Mumbai?',
    answer: 'Yes, you can specify your preferred pickup and drop-off locations to match your travel plans.',
  },
  {
    question: 'What payment options are available for car rentals with drivers in Mumbai?',
    answer: 'We accept cash, cards, UPI, and popular digital wallets for hassle-free payments.',
  },
  {
    question: 'Can I pre-book car rentals with drivers in Mumbai?',
    answer: 'Yes, Aaryan Travels allows advance bookings to ensure your car and driver are ready when you need them.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Sharma',
    feedback: 'Aaryan Travels made car rental with driver in Mumbai easy and comfortable. The driver was punctual and courteous.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ananya Desai',
    feedback: 'Excellent service and clean cars. Renting a car with driver in Mumbai through Aaryan Travels was a great experience.',
    rating: 5,
  },
];































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Car Rentals with Drivers in Mumbai",
  "image": "https://aaryantravels.com/assets/images/car-rental-with-driver-mumbai.jpg", // replace with actual image URL
  "description": "Book reliable car rentals with drivers in Mumbai from Aaryan Travels. Enjoy comfortable rides with professional chauffeurs for local, corporate, and outstation travel at affordable rates.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",  // example rating
    "ratingCount": "2600", // example rating count
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500",  // example price
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/car-rentals-with-drivers-in-mumbai"
  }
};





  return (
    <div>

<Helmet>
  <title>Car Rentals with Drivers in Mumbai | Luxury & Affordable Car Hire | Aaryan Travels</title>
  <meta
    name="description"
    content="Book reliable car rentals with drivers in Mumbai from Aaryan Travels. Enjoy comfortable rides with professional chauffeurs for local, corporate, and outstation travel at affordable rates."
  />
  <meta
    name="keywords"
    content="Car Rentals with Drivers in Mumbai, Mumbai Car Hire with Driver, Chauffeur Driven Car Rental Mumbai, Luxury Car with Driver Mumbai, Executive Car Rental Mumbai, Best Driver Car Rentals Mumbai, Affordable Car Rental with Driver Mumbai, Corporate Car Hire Mumbai, Sedan Car with Driver Mumbai, SUV Rental with Driver Mumbai, Premium Car & Driver Mumbai, Monthly Car with Driver Mumbai, Online Car with Driver Mumbai, One Day Car with Driver Mumbai, Mumbai Chauffeur Car Services"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/37.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Carrentalswithdriversinmumbai;